const $ = window.jQuery;

const BoxInfoBlock = {
	init() {
		const $module = $('.yg-box-block');

		if (!$module.length) return;

		const category = $module.find('.yg-box-block__categori');

		const accodionItem = category.find('.accordion-item');

		category.on('click', '.accordion-item', function () {
			$(this).parent().find('.active').removeClass('active');

			$(this).addClass('active');

			const itemIndex = $(this).attr('data-index');
			console.log(itemIndex);
			$(this).closest('.yg-box-block__categori').find(`.accorion-content`).hide();

			const content = $(this).closest('.yg-box-block__categori').find(`.accorion-content[data-index="${itemIndex}"]`);
			content.show();
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: content.offset().top - 200,
				},
				500
			);
		});

		const toggles = $module.find('.yg-box-block__toggles button');
		toggles.on('click', function () {
			const toggle = $(this);
			const target = toggle.attr('data-togglefor');
			const toggleContent = $module.find(`.yg-box-block__categori#${target}`);

			toggles.removeClass('active');
			toggle.addClass('active');

			$module.find('.yg-box-block__categori').removeClass('active');
			toggleContent.addClass('active');
		});
	},
};

export default BoxInfoBlock;
